import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom'

const Register = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError(''); // изчистване на предишни грешки

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, email, password })
      });

      if (res.ok) {
        navigate('/login', { state: { registered: true } });
      } else {
        const data = await res.json();

        if (Array.isArray(data.detail)) {
          // Ако има списък с Pydantic грешки
          const messages = data.detail.map(d => d.msg).join(', ');
          setError(messages);
        } else if (data.detail) {
          setError(data.detail);
        } else {
          setError('Registration failed. Try another email or username.');
        }
      }
    } catch (err) {
      console.error('Unexpected registration error:', err);
      setError('Unexpected error occurred. Please try again.');
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-[#140D4F]">
      <form onSubmit={handleRegister} className="bg-white p-8 rounded-2xl shadow-xl w-96">
        <h1 className="text-[#140D4F] text-3xl font-bold text-center mb-2">
          <Link to="/" className="hover:underline">DiagCode.AI</Link>
        </h1>
        <p className="text-gray-600 text-sm text-center mb-6">
          Your assistant for advanced vehicle diagnostics and repair insights.
        </p>

        <h2 className="text-[#140D4F] text-2xl font-semibold mb-4 text-center">Register</h2>
        {error && <p className="text-red-400 mb-3 text-sm">{error}</p>}

        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="w-full p-2 mb-4 rounded border border-gray-300 text-black placeholder-gray-500"
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-2 mb-4 rounded border border-gray-300 text-black placeholder-gray-500"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-2 mb-4 rounded border border-gray-300 text-black placeholder-gray-500"
        />
        <button
          type="submit"
          className="w-full bg-[#FD5003] hover:bg-[#e34700] text-white py-2 rounded font-semibold transition"
        >
          Register
        </button>
        <p className="text-gray-300 text-sm mt-4 text-center">
          Already have an account? <a href="/login" className="text-[#0267C1] hover:underline">Login</a>
        </p>
      </form>
    </div>
  );
};

export default Register;
